import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { FormikFormGroup, TimeUnitInput } from "components/common";
import { useValidateDataAdapter } from "components/lookup-tables/hooks/useLookupTablesAPI";
import AdapterConfigFormFields from "./AdapterConfigFormFields";
function AdapterFormFields() {
  const { errors, values, touched, setFieldValue, setValues, setErrors } = useFormikContext();
  const { validateDataAdapter } = useValidateDataAdapter();
  const configRef = useRef(null);
  const [generateName, setGenerateName] = useState(!values.title);
  const _sanitizeName = (inName) => inName.trim().replace(/\W+/g, "-").toLocaleLowerCase();
  const _runValidations = useCallback(() => {
    validateDataAdapter(values).then((resp) => {
      var _a, _b;
      const auxErrors = Object.keys(resp.errors).reduce((acc, key) => {
        if (errors[key]) acc[key] = errors[key];
        else acc[key] = resp.errors[key][0];
        return acc;
      }, {});
      const configErrors = ((_b = (_a = configRef == null ? void 0 : configRef.current) == null ? void 0 : _a.validate) == null ? void 0 : _b.call(_a)) || {};
      setErrors({ ...auxErrors, ...configErrors });
    });
  }, [validateDataAdapter, values, setErrors, errors]);
  const handleTitleChange = (event) => {
    if (!generateName) return;
    const safeName = _sanitizeName(event.target.value);
    setValues({
      ...values,
      title: event.target.value,
      name: safeName
    });
  };
  useEffect(() => _runValidations(), [_runValidations, values]);
  const updateCustomErrorTTL = (value, unit, enabled) => {
    setFieldValue("custom_error_ttl", value);
    setFieldValue("custom_error_ttl_unit", unit);
    setFieldValue("custom_error_ttl_enabled", enabled);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "title",
      label: "* Title",
      required: true,
      onChange: handleTitleChange,
      help: touched.title && errors.title ? null : "A short title for this data adapter.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "description",
      label: "Description",
      help: "Data adapter description.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "name",
      label: "* Name",
      required: true,
      error: touched.name && errors.name ? errors.name : null,
      onChange: () => setGenerateName(!touched.name),
      help: touched.name && errors.name ? null : "The name that is being used to refer to this data adapter. Must be unique.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "Custom Error TTL",
      help: "Define a custom TTL for caching erroneous results. Otherwise the default of 5 seconds is used",
      update: updateCustomErrorTTL,
      value: values.custom_error_ttl,
      unit: values.custom_error_ttl_unit || "MINUTES",
      units: ["MILLISECONDS", "SECONDS", "MINUTES", "HOURS", "DAYS"],
      enabled: values.custom_error_ttl_enabled,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(AdapterConfigFormFields, { ref: configRef, validationErrors: errors }));
}
export default AdapterFormFields;
